'use client';

import React, { useEffect, useRef } from 'react';

import styles from './styles.module.scss';

interface Props {
  className?: string;
  children?: React.ReactNode;
  onHeightChange?: (height: number) => void;
}

const BottomFixed = (props: Props) => {
  const { className = '', children } = props;
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if(!ref.current) return;

    props.onHeightChange?.call(null, ref.current.offsetHeight);
  }, [ref, props.onHeightChange]);

  return <div
    ref={ref}
    className={`${styles.bottomFixed} ${className}`}>
    {children}
  </div>;
};

export default BottomFixed;